<div class="popup-backdrop" *ngIf="show" (click)="$event.stopPropagation()">
  <div class="popup">
    <div class="popup-header">
      <h1>{{ options.title }}</h1>
    </div>
    <div class="popup-body">
      <p>{{ options.message }}</p>
    </div>
    <div class="popup-footer">
      <button (click)="onConfirm()" class="button primary">
        {{ options.confirmText }}
      </button>
      <button (click)="onCancel()" class="button">
        {{ options.cancelText }}
      </button>
    </div>
  </div>
</div>
